const initializeSwiper = () => {
	// Hero Carousel
if (document.querySelector('.hero-carousel') && document.querySelectorAll('.hero-carousel .swiper-slide').length > 1) { 
	const isAutoplayEnabled = document.querySelector('.hero-carousel').classList.contains('autoplay-enabled');

	const heroCarousel = new Swiper('.hero-carousel', {
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		autoplay: isAutoplayEnabled ? {
			delay: 15000,
			disableOnInteraction: true,
		} : false,
		disableOnInteraction: true,
		mousewheel: {
			forceToAxis: true,
		},
		speed: 800,
		slidesPerView: 1,
		loop: true,
	});
	const pauseButton = document.querySelector('.swiper-button-pause');
	const playButton = document.querySelector('.swiper-button-play');
	
	pauseButton.addEventListener('click', function (e) {
		this.classList.toggle('sr-only');
		playButton.classList.toggle('sr-only');
		heroCarousel.autoplay.stop();
	});
	
	playButton.addEventListener('click', function (e) {
		this.classList.toggle('sr-only');
		pauseButton.classList.toggle('sr-only');
		heroCarousel.autoplay.start();
	});
}


if (document.querySelector('.category-carousel')) { 
	const isAutoplayEnabled = document.querySelector('.category-carousel-wrapper').classList.contains('autoplay-enabled');


	const categoryCarousel = new Swiper('.category-carousel', {
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		speed: 800,
		loop: false,
		slidesPerView: 1,
		centeredSlides: false,
		autoplay: isAutoplayEnabled ? {
			delay: 1500,
			disableOnInteraction: true,
		} : false,
	});
}



//Feature Content Carousel
if (document.querySelector('.featured-content-carousel')) { 

	const isAutoplayEnabled = document.querySelector('.featured-content-carousel').classList.contains('autoplay-enabled');

	const featuredCarousel = new Swiper('.featured-content-carousel', {
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		mousewheel: {
			forceToAxis: true,
		},
		speed: 800,
		loop: true,
		slidesPerView: 1,
		centeredSlides: true,
		autoplay: isAutoplayEnabled ? {
			delay: 15000,
			disableOnInteraction: true,
		} : false,
		breakpoints: {
			1024: {
				slidesPerView: 1.25
			}
		}
	});
}


if (document.querySelector('.story-carousel')) { 

	const isAutoplayEnabled = document.querySelector('.story-carousel').classList.contains('autoplay-enabled');

	const storyCarousel = new Swiper('.story-carousel', {
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		mousewheel: {
			forceToAxis: true,
		},
		autoplay: isAutoplayEnabled ? {
			delay: 15000,
			disableOnInteraction: true,
		} : false,
		speed: 300,
		loop: true,
		slidesPerView: 1.25,
		centeredSlides: false,
		spaceBetween: 20,
		breakpoints: {
			768: {
				slidesPerView: 2.5,
			},
			1024: {
				slidesPerView: 3.5,
				spaceBetween: 24
			}
		}
	});
}




	if (document.querySelector('.solution-carousel')) { 

		const isAutoplayEnabled = document.querySelector('.solution-carousel').classList.contains('autoplay-enabled');

		const solutionCarousel = new Swiper('.solution-carousel', {
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			loop: false,
			speed: 300,
			slidesPerView: 1.5,
			centeredSlides: false,
			spaceBetween: 15,
			breakpoints: {
				768: {
					slidesPerView: 2.5
				},
				1024: {
					spaceBetween: 25,
					slidesPerView: 3.5
				},
				1440: {
					spaceBetween: 25,
					slidesPerView: 4.25
				}
			},
			autoplay: isAutoplayEnabled ? {
				delay: 15000,
				disableOnInteraction: true,
			} : false,
		});
	}
};


document.addEventListener("DOMContentLoaded", () => {
    setTimeout(initializeSwiper, 1000); 
});